import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'bms-common-page-main-title',
  templateUrl: './bms-common-page-main-title.component.html',
  styleUrls: ['./bms-common-page-main-title.component.scss'],
})
export class BMSCommonPageMainTitleComponent implements OnChanges {
  @Input() icon: string;
  // Primary Button
  @Input() isSideButtonEnabled = true;
  @Input() sideButtonText = 'Add New';
  @Input() isSideButtonShow = false;
  // Secondary Button
  @Input() isSecondaryButtonEnabled = true;
  @Input() secondaryButtonText = 'Add New';
  @Input() isSecondaryButtonShow = false;
  // Tertiary Button
  @Input() isTertiaryButtonEnabled = true;
  @Input() tertiaryButtonText = 'Download Members';
  @Input() isTertiaryButtonShow = false;
  @Input() title: string;
  @Input() subTitle: string;

  @Output() onSideButtonClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onSecondaryButtonClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onTertiaryButtonClick: EventEmitter<boolean> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isSideButtonEnabled) {
      this.isSideButtonEnabled = changes.isSideButtonEnabled.currentValue;
    }
    if (changes.isSideButtonShow) {
      this.isSideButtonShow = changes.isSideButtonShow.currentValue;
    }
  }

  onSideButton() {
    this.onSideButtonClick.emit(true);
  }

  onSecondaryButton() {
    this.onSecondaryButtonClick.emit(true);
  }

  onTertiaryButton() {
    this.onTertiaryButtonClick.emit(true);
  }
}
